import {
  ALL_PERSONAL_LIFE_HISTORY_IDS,
  PERSONAL_LIFE_HISTORY_IDS,
  PREVIEW_TITLE_CODES,
} from "~/providers/constants/SummariesExpandableIds";
import Expandable from "../common/Expandable";

export interface PersonalLifeHistoryProps {
  substance_history: string;
  past_personal_history: string;
  educational_history: string;
  family_history: string;
}

export const PersonalLifeHistory = ({
  educational_history,
  family_history,
  past_personal_history,
  substance_history,
}: PersonalLifeHistoryProps) => (
  <Expandable.Wrapper
    code={PREVIEW_TITLE_CODES.PERSONAL_LIFE_HISTORY}
    expandableSections={[...ALL_PERSONAL_LIFE_HISTORY_IDS]}
  >
    <Expandable.Section code={PERSONAL_LIFE_HISTORY_IDS.SUBSTANCE_HISTORY}>
      {substance_history}
    </Expandable.Section>
    <Expandable.Section code={PERSONAL_LIFE_HISTORY_IDS.PAST_PERSONAL_HISTORY}>
      {past_personal_history}
    </Expandable.Section>
    <Expandable.Section code={PERSONAL_LIFE_HISTORY_IDS.EDUCATIONAL_HISTORY}>
      {educational_history}
    </Expandable.Section>
    <Expandable.Section
      code={PERSONAL_LIFE_HISTORY_IDS.FAMILY_HISTORY}
      className="border-none pb-0"
    >
      {family_history}
    </Expandable.Section>
  </Expandable.Wrapper>
);
